
/* 
Collapseable Menu Button Animation
*/

(function ($) {

	var $menuBtn = $("#js-c-menu_btn");

	$menuBtn.on("click", function (e) {
		$menuBtn.toggleClass("is-active");

		$("body").toggleClass("has-menu-open");
	});


var $circle = $('#radial-gradient'),
      $wrapper = $(document); 

    var flag = false;

    $($wrapper).mouseover(function(){
      flag = true;
      TweenLite.to($circle,0.4,{scale:1,autoAlpha:.5})
      $($wrapper).on('mousemove', moveCircle);

    });

    $($wrapper).mouseout(function(){
        flag = false;
        TweenLite.to($circle,0.4,{scale:1,autoAlpha:.5})
    });

     function moveCircle(e) {
        TweenLite.to($circle, .5, {ease: Sine.easeInOut,
          css: {
            left: e.pageX,
            top: e.pageY
          }
        });
      } 


function isScrolledIntoView(elem) {
    var docViewTop = $(window).scrollTop();
    var docViewBottom = docViewTop + $(window).height();

    var elemTop = $(elem).offset().top+250;
    var elemBottom = elemTop + $(elem).height();

    return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
}

$(window).scroll(function () {
    $('.c-title').each(function () {
        if (isScrolledIntoView(this) === true) {
            $(this).addClass('visible');
        }
    });

}); 

$(window).on('load', function() {
 $('.grid').masonry({
  // options...
  itemSelector: '.grid-item'
  
});
});


  $(window).scroll(function() {    
    var scroll = $(window).scrollTop();

     //>=, not <=
    if (scroll >= 400) {
        //clearHeader, not clearheader - caps H
        $('.c-site-header').addClass("active");
         $('body').addClass("menu-active");
    }else{
        $('.c-site-header').removeClass("active");
         $('body').removeClass("menu-active");
    }
});

})(jQuery);
